<template>
  <div>
    <div v-for="item in list" :key="item.id" style="display: flex;white-space: nowrap">
      <div
        :class="{selected: item.selected}"
        class="selection"
		:style="{minWidth: width?'auto':'460px'}"
        @click="selectPayWay(item)"
      >
        {{item.activityName}}（当前{{name}}次数可用{{item.gift ? (item.gift.countNumber||0) : 0}}次）
      </div>
      <div v-if="item.gift.isVipRight && item.gift.countNumber === 0 || item.gift.isVipRight && item.gift.countNumber<batchNum">
        <template v-if="userInfo.realNameStatus != 'complete_real_name'">
          <span @click="goRealname()" class="pay-link">会员购买</span>
        </template>
        <span class="pay-link" @click="buyVip()" v-if="userInfo.realNameStatus == 'complete_real_name' && userInfo.vipFlag == '0'">会员购买</span>
        <span class="pay-link" @click="buyVip()" v-if="userInfo.realNameStatus == 'complete_real_name' && userInfo.vipFlag == '2'">会员购买</span>
        <template v-if="userInfo.realNameStatus == 'complete_real_name' && userInfo.vipFlag == '1'">
          <span class="pay-link" @click="myczPayState = true" v-if="isRenew == false ? false : true" >会员续费</span>
          <span class="pay-link" @click="monitorBagState = true">购买加油包</span>
        </template>
      </div>
    </div>
    <!--    加油包    -->
    <monitorBag :bizType="bizType" :subBizType="type" v-if="monitorBagState" @monitorBagFather="initPayWay();monitorBagState = false"/>
    <!--    会员续费    -->
    <myczPay v-if="myczPayState" mywidth='838' myheight="585" myTitleheight="50" @fatherModal="initPayWay();myczPayState = false"/>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import monitorBag from '@/views/vipClip/monitor/components/monitorBag';
import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay';
import {userInfo} from "@/api/index";

export default {
  name: "payWay",
  props: ["type","batchNum", "width","isRenew"],
  data() {
    return {
      list: [],
      vipRight: null,
      monitorBagState: false,
      myczPayState: false,
      name: '',
      userInfo: {},
      bizType:''
    };
  },
  components:{
      monitorBag,
      myczPay,
  },
  methods: {
    buyVip() {
//      if (this.userInfo.accountType == 'person') {
//        this.$router.push({path: '/vipPersonal'})
//      } else {
//        this.$router.push({path: '/vipEnterprise'})
//      }
      this.$router.push({path: '/huiyuan.html'})
    },
    goRealname() {
      let that = this;
      userInfo().then(res=>{
        Cookies.set("userInfo", JSON.stringify(res.result));
        that.setStore("userInfo", res.result);
        that.userInfo = JSON.parse(Cookies.get("userInfo"))
        if(that.userInfo.realNameStatus == 'complete_real_name'){
          that.buyVip();
        }
        else{
          toast('请实名认证后再操作');
          that.$router.push({path: '/authentication'})
        }
      },err=>{console.log(err)});


      // if (this.userInfo.accountType == 'person') {
      //   this.$router.push({path: '/personalAuthentication'})
      // } else {
      //   this.$router.push({path: '/enterpriseAuthentication1'})
      // }
    },
    selectPayWay(activity) {
      if (activity.gift.countNumber > 0) {
        this.list = this.list.map(item => ({...item, selected: activity.id === item.id}))
        this.$emit('onselected', activity)
      } else {
        toast('无可用次数')
      }
    },
    findCurrentTypeGift(activity) {
      return this.getRequest(
        "/activityRegisterActivation/info?activityGiftId=" + activity.activityGiftId
      ).then(data => {
        if (data.result) {
          // 根据传进来的 [type] 筛选当前类型礼包 如：存证
          const currentGift = data.result.find(
            gift => (gift.type === this.type || (gift.type === '02' && '0202' === this.type)) && gift.countNumber > 0
          );
          return { ...activity, gift: currentGift };
        }
      });
    },
    initActivityPayWayList() {
      return this.getRequest("/activityRegisterActivation/list").then(data => {
        if (data.success) {
          const list = data.result;
          if (list && list.length > 0) {
            return Promise.all(list.map(this.findCurrentTypeGift)).then(res => {
              // 过滤无礼包活动
              return res.filter(item => item.gift);
            });
          }
        }
      });
    },
    initVipRights() {
      try {
        this.userInfo = JSON.parse(Cookies.get("userInfo"))
        console.log(this.userInfo)
        return this.getRequest("/registerVipMemberRights/get?registerId=" + this.userInfo.id).then(data => {
          if (data.success) {
            console.log(data)
            return this.getVipRights(data.result)
            // return data.result;
          }
        });
      } catch (error) {
        console.error(error)
      }
    },
    getVipRights(types) {
      switch (this.type) {
        case '01':
          // 版权存证
          this.name = '存证';
          this.bizType = '01';
          return types.evidenceArchiveNum
        case '0202':
          // 版权存证
          this.name = '电子登记';
          this.bizType = '02';
          return types.copyrightRegisterNum
        case '0211':
          // 纸质登记
          this.name = '纸质登记';
          this.bizType = '02';
          return types.paperCopyrightRegisterNum
        case '0212':
          //证书查询
          this.name = '证书查询';
          this.bizType = '02';
          return types.copyrightRegisterFindNum
        case '0213':
          //证书撤销
          this.name = '证书撤销';
          this.bizType = '02';
          return types.copyrightRegisterCancelNum
        case '0214':
          //作品变更
          this.name = '作品变更';
          this.bizType = '02';
          return types.copyrightRegisterUpdateNum
        case '0401':
          // 图片监测
          this.name = '图片监测';
          this.bizType = '04';
          return types.imageMonitorNum
        case '0403':
          // 音乐监测
          this.name = '音乐监测';
          this.bizType = '04';
          return types.musicMonitorNum
        case '0402':
          // 文字监测
          this.name = '文字监测';
          this.bizType = '04';
          return types.textMonitorNum
        case '03':
          // 版权取证
          this.name = '版权取证';
          this.bizType = '03';
          return types.forensicsNum
        case '0501':
          // 电话问律师30分钟
          this.name = '电话问律师30分钟';
          this.bizType = '05';
          return types.lawyerConsult30Num
        case '0502':
          // 电话问律师60分钟
          this.name = '电话问律师60分钟';
          this.bizType = '05';
          return types.lawyerConsult60Num
        case '050511':
          // 侵权下架
          this.name = '侵权下架';
          this.bizType = '05';
          return types.tortShelvesNum
        case '0503':
          // 合同审核
          this.name = '合同审核';
          this.bizType = '05';
          return types.contractAuditNum
        case '0505':
          // 侵权判定+维权方案设计
          this.name = '侵权判定+维权方案设计';
          this.bizType = '05';
          return types.infringementDeterminationNum
        case '0506':
          // 出具律师函
          this.name = '出具律师函';
          this.bizType = '05';
          return types.lawyerLetterNum

        case '13':
          // 电子公证
          this.name = '电子数据确认函';
          this.bizType = '13';
          return types.notarizationNum
        default:
          break;
      }
    },
    initPayWay() {
      Promise.all([
        this.initActivityPayWayList(),
        this.initVipRights()
      ]).then(res => {
        this.list = res[0] || [];
        this.list.unshift({
          activityName: '版权家会员权益支付',
          gift: {
            countNumber: res[1],
            isVipRight: true,
          }
        })
        // this.list[0].selected = true;
        const shouldSelect = this.list.find(item => item.gift && item.gift.countNumber > 0);
        if (shouldSelect) {
          console.log(shouldSelect)
          shouldSelect.selected = true
          this.$emit('onselected', shouldSelect)
        }
        else{
          this.$emit('onselected', null)
        }
      })
    }
  },
  created() {
  	console.log("我也来了，我是payway")
    this.initPayWay()
//  this.getRequest('/activityGift/getGiftBizTypeList').then(data => console.log(data))
  }
};
</script>

<style lang="less">
.pay-link {
  text-decoration: underline;
  color:rgba(51,51,51,1);
  cursor: pointer;
  line-height: 42px;
  margin-left: 30px;
}
.selection {
  min-width: 460px;
  height: 42px;
  border-radius: 2px;
  padding: 0 25px;
  display: flex;
  align-items: center;
  border: 1px solid rgba(199, 199, 199, 1);
  cursor: pointer;
  margin-bottom: 20px;
  &.selected {
    background: rgba(255, 216, 0, 1);
    border: 1px solid transparent;
  }
}
</style>
